import { FC } from 'react';
import { OrderNotesSwitchers } from '../../containers/OrderNotesSwitchers/OrderNotesSwitchers';

export const OrderNotes: FC = (): JSX.Element => {
  return (
    <>
      <OrderNotesSwitchers />
      {/* <OrderCrossSellingOptions />*/}
    </>
  );
};
